<template>
	<div class="home-banner" id="home-banner">
		<div class="pic">
			<div class="pic-content" v-for="(item, index) in list" :key="index" :style="{ opacity: activeIndex == index ? 1 : 0 }" @click="linkUrl(item)">
				<template v-if="isPc">
					<video class="img" v-if="item['coverUrl' + En].includes('.mp4')" playsinline webkit-playsinline :src="item['coverUrl' + En]" autoplay muted="muted"></video>
					<img class="img" v-else :src="item['coverUrl' + En]" alt="">
				</template>
				<template v-else>
					<video class="img" v-if="item['phoneCoverUrl' + En].includes('.mp4')" playsinline webkit-playsinline :src="item['phoneCoverUrl' + En]" autoplay muted="muted"></video>
					<img class="img" v-else :src="item['phoneCoverUrl' + En]" alt="">
				</template>
			</div>
		</div>
		<div class="dots">
			<div class="dot" :class="activeIndex == index ? 'active' : ''" @click="activeIndex = index" v-for="(item, index) in list" :key="index"></div>
		</div>
		<div class="left">
			<div class="item">
				<div class="text1"><span>{{ $t('newbanner1') }}</span></div>
				<div class="text2">{{ En ? 'September 23-27' : '9月23日-27日' }}</div>
				<div class="text3">{{ En ? '2025' : '2025年' }}</div>
			</div>
			<div class="item">
				<div class="text1"><span>{{ $t('newbanner2') }}</span></div>
				<div class="text2">{{ En ? 'National Exhibition & Convention Center' : '国家会展中心' }}</div>
				<div class="text3">{{ En ? 'Shanghai · China ' : '中国 · 上海' }}</div>
			</div>
		</div>
		<div class="right">
			<img class="banner-logo" v-if="En" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/banner-logo-en.png" alt="">
			<img class="banner-logo" v-else src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/banner-logo.png" alt="">

			<div class="btns">
				<el-tooltip v-if="visitorIsClose" popper-class="expect-tooltips" effect="dark" :content="En ? 'Coming Soon' : '暂未开放 敬请期待'" placement="top">
					<a class="btn" href="javascript:void(0)">
						{{ $t('newbanner3') }}
						<img class="img1" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/right-black.png" alt="">
						<img class="img2" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/right-white.png" alt="">
					</a>
				</el-tooltip>
				<a class="btn" :href="En ? 'https://www.ciif-expo.cn/ciifVisitor/AudienceEn/ExchSelect?registrationCode=MK-guanwangcaidanEN' : 'https://www.ciif-expo.cn/ciifVisitor?registrationCode=MK-guanwangcaidanCN'">
				<!-- <a class="btn" href="javascript:void(0)" @click="toRegister"> -->
					{{ $t('newbanner3') }}
					<img class="img1" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/right-black.png" alt="">
					<img class="img2" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/right-white.png" alt="">
				</a>
				<a class="btn" href="javascript:void(0)" @click="toApply">
					{{ $t('newbanner4') }}
					<img class="img1" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/right-black.png" alt="">
					<img class="img2" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/right-white.png" alt="">
				</a>
			</div>
		</div>
	</div>
</template>

<script>
import protal from "@/api/protal";
export default {
	name: 'news_events',
	data() {
		return {
			activeIndex: 0,
			list: [],
			timer: null
		}
	},
	created() {
		this.getData()
	},
	methods: {
		getData() {
			protal.webBannerlist().then(res => {
				this.list = res.data

				clearInterval(this.timer)
				this.timer = setInterval(() => {
					if (this.activeIndex == (this.list.length - 1)) {
						this.activeIndex = 0
					} else {
						this.activeIndex++
					}
				}, 5000)
			})
		},
		toRegister() {
			if (this.En) {
				this.$router.push('/registerEn')
			} else {
				this.$router.push('/register')
			}
		},
		toApply() {
			this.$router.push('/match_apply')
		},
		linkUrl(item) {
			if (item.linkUrl) {
				location.href = item.linkUrl
			}
		}
	}
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 769px) {
	.home-banner {
		position: relative;
		width: 100%;
		height: 1080px;

		.pic {
			position: relative;
			width: 100%;
			height: 100%;

			.pic-content {
				position: absolute;
				width: 100%;
				height: 100%;
				left: 0;
				top: 0;
				transition: 0.5s;

				// &::before {
				// 	content: "";
				// 	position: absolute;
				// 	left: 0;
				// 	top: 0;
				// 	right: 0;
				// 	bottom: 0;
				// 	background-color: rgba(255, 255, 255, 0.3);
				// }
			}

			.img {
				display: block;
				width: 100%;
				height: 100%;
			}
		}

		.dots {
			position: absolute;
			left: 140px;
			bottom: 73px;

			.dot {
				width: 5px;
				height: 48px;
				background: rgba(255, 255, 255, 0.4);
				border-radius: 3px;
				margin-bottom: 20px;
				transition: 0.3s;
				cursor: pointer;
				cursor: pointer;

				&.active {
					background: #F4501C;
				}
			}
		}

		.left {
			position: absolute;
			left: 220px;
			top: 322px;

			.item {
				margin-bottom: 60px;

				.text1 {
					
					span {
						font-family: Regular;
						font-weight: 400;
						font-size: 18px;
						color: #0B243F;
						line-height: 18px;
						text-align: left;
						font-style: normal;
						text-transform: uppercase;
						position: relative;
						display: inline-block;

						&::before {
							content: "";
							position: absolute;
							left: 0;
							right: 0;
							top: -5px;
							height: 1px;
							background: #3A4E64;
						}
					}
				}

				.text2 {
					margin: 11px 0 8px;
					font-family: sy;
					font-weight: 500;
					font-size: 30px;
					color: #0B243F;
					line-height: 30px;
					text-align: left;
					font-style: normal;
				}

				.text3 {
					font-family: Regular;
					font-weight: 400;
					font-size: 24px;
					color: #0B243F;
					line-height: 24px;
					text-align: left;
					font-style: normal;
				}
			}
		}

		.right {
			position: absolute;
			left: 920px;
			top: 320px;

			.banner-logo {
				width: auto;
				height: 228px;
				margin-bottom: 60px;
			}

			.btns {
				display: flex;

				.btn {
					height: 56px;
					border: 1px solid rgba(11, 36, 63, 0.6);
					border-radius: 12px;
					font-family: Inter Medium, sy;
					font-weight: 500;
					font-size: 16px;
					color: #0B243F;
					line-height: 16px;
					text-align: left;
					font-style: normal;
					padding: 0 28px 0 20px;
					display: flex;
					align-items: center;
					justify-content: center;
					margin-right: 16px;
					cursor: pointer;

					img {
						width: 24px;
						height: auto;
						margin-left: 12px;
						display: none;

						&.img1 {
							display: block;
						}

						&.img2 {
							display: none;
						}
					}

					&:hover {
						background-color: #F4501C;
						border-color: #F4501C;
						color: #fff;

						img {

							&.img1 {
								display: none;
							}

							&.img2 {
								display: block;
							}
						}
					}
				}
			}
		}
	}
}

@media screen and (max-width: 768px) {
	.home-banner {
		position: relative;
		width: 100%;
		height: 12.8rem;

		.pic {
			position: relative;
			width: 100%;
			height: 100%;

			.pic-content {
				position: absolute;
				width: 100%;
				height: 100%;
				left: 0;
				top: 0;
				transition: 0.5s;

				// &::before {
				// 	content: "";
				// 	position: absolute;
				// 	left: 0;
				// 	top: 0;
				// 	right: 0;
				// 	bottom: 0;
				// 	background-color: rgba(255, 255, 255, 0.3);
				// }
			}

			.img {
				display: block;
				width: 100%;
				height: 100%;
			}
		}

		.dots {
			position: absolute;
			left: 0.36rem;
			bottom: 0.28rem;

			.dot {
				width: 0.05rem;
				height: .48rem;
				background: rgba(255, 255, 255, 0.4);
				border-radius: .03rem;
				margin-bottom: .2rem;
				transition: 0.3s;
				cursor: pointer;
				cursor: pointer;

				&.active {
					background: #F4501C;
				}
			}
		}

		.left {
			position: absolute;
			left: .6rem;
			top: 1.68rem;

			.item {
				margin-bottom: .4rem;

				.text1 {
					
					span {
						font-family: Regular;
						font-weight: 400;
						font-size: .18rem;
						color: #0B243F;
						line-height: .18rem;
						text-align: left;
						font-style: normal;
						text-transform: uppercase;
						position: relative;
						display: inline-block;

						&::before {
							content: "";
							position: absolute;
							left: 0;
							right: 0;
							top: -4px;
							height: 1px;
							background: #3A4E64;
						}
					}
				}

				.text2 {
					margin: .08rem 0;
					font-family: sy;
					font-weight: 500;
					font-size: .28rem;
					color: #0B243F;
					line-height: .28rem;
					text-align: left;
					font-style: normal;
				}

				.text3 {
					font-family: Regular;
					font-weight: 400;
					font-size: .22rem;
					color: #0B243F;
					line-height: .22rem;
					text-align: left;
					font-style: normal;
				}
			}
		}

		.right {
			position: absolute;
			left: 0.6rem;
			top: 5.2rem;

			.banner-logo {
				width: 6.3rem;
				height: auto;
				margin-bottom: .52rem;
			}

			.btns {
				display: flex;

				.btn {
					height: .88rem;
					border: 1px solid rgba(11, 36, 63, 0.6);
					border-radius: 0.2rem;
					font-family: Inter Medium, sy;
					font-weight: 500;
					font-size: .24rem;
					color: #0B243F;
					line-height: .24rem;
					text-align: left;
					font-style: normal;
					padding: 0 .28rem;
					display: flex;
					align-items: center;
					justify-content: center;
					margin-right: .16rem;
					cursor: pointer;

					img {
						width: .36rem;
						height: auto;
						margin-left: .12rem;
						display: none;

						&.img1 {
							display: block;
						}

						&.img2 {
							display: none;
						}
					}

					&:hover {
						background-color: #F4501C;
						border-color: #F4501C;
						color: #fff;

						img {

							&.img1 {
								display: none;
							}

							&.img2 {
								display: block;
							}
						}
					}
				}
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/home/components/banner.vue